export default {

  required: {
    message : "Bet is not set!",
    fn      : (input)=>  Boolean(input)
  },

}
